import { withTranslation } from "react-i18next";

function MessageFromServer({t, codeMessage, codeServer}){

    if(codeMessage==="SCH-01" || codeMessage==='SCH-02'){
        return t('SCH-01')
    }else if(codeServer === 409){
        return t('server_302')
    }else if(codeServer === 404){
        return t('server_404')
    }else if(codeServer === 400){
        return codeMessage
    }else{
        return 'Error desde el servidor. Contactar al administrador.'
    }



}

export default withTranslation()(MessageFromServer)